import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-tv",
  templateUrl: "./med-icon-tv.component.html",
})
export class MedIconTvComponent extends SvgMixinComponent {}
